import "./About.css";
import { useState } from "react";

const About = () => {
  const [currentImage, setCurrentImage] = useState(`${process.env.PUBLIC_URL}/mehehe.jpg`);

  const handleMouseEnter = () => {
    setCurrentImage(`${process.env.PUBLIC_URL}/more.png`);
  };

  const handleMouseLeave = () => {
    setCurrentImage(`${process.env.PUBLIC_URL}/mehehe.jpg`);
  };
  return (
    <div className="about-me-container">
      <div className="photo-container">
        <img
          className="photo"
          src={currentImage}
          alt="Valeria standing in front of some trees. She is wearing a black jacket and glasses, and is smiling at the camera."
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </div>
      <div className="about-me-text">
        <h1 className="about">About Me</h1>
        <p>
          Hello! I am a web developer living in Chicago, and I love
          creating websites that are not just functional, but accessible to
          everyone. I graduated from Calvin University in December 2020 with a
          Bachelor's in Computer Science and a minor in Political Science.
          Originally from Honduras, I bring a unique blend of cultural and
          technical insights to everything I do.
            </p>
        <p>
          By day, I work in Health tech, but when I'm off the clock, you'll
          often find me wandering around the city
          on aimless walks, joining a fun group fitness class, beautifying Montefresco, my Animal Crossings island, or attempting to do pottery!
          I also love trying out new recipes in the kitchen ◡̈
        </p>
        <p>
          I am passionate about making the web a more inclusive place, and I am
          always looking for new ways to ensure that everyone can enjoy the
          digital experiences I help create.
          </p>
      </div>

    </div>
  );
};

export default About;
